module.exports = __webpack_public_path__ + "img/language_hover.589079d6.png";